import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { HeaderComponent } from './layouts/header/header.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { PrimengModule } from './shared/modules/primeng.module';
import { SharedModule } from './shared/modules/shared.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CompanyNewOrderDialogComponent } from './company/company-new-order-dialog/company-new-order-dialog.component';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { environment } from '../environments/environment';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { AvatarComponent } from './shared/components/avatar/avatar.component';
import { UsersListComponent } from './pages/shared-components/users-list/users-list.component';
import { AuthenticationLayoutComponent } from './layouts/authentication-layout/authentication-layout.component';

import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { MyGuidesComponent } from './company/my-guides/my-guides.component';
import { MyContactsComponent } from './company/my-contacts/my-contacts.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    MainLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    UsersListComponent,
    AuthenticationLayoutComponent,
    MyGuidesComponent,
    MyContactsComponent,
    CompanyNewOrderDialogComponent,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireFunctionsModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,

    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    PrimengModule,
    SharedModule,
    NgxMaterialTimepickerModule,
    LeafletModule,
    HttpClientModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
